import { useQueryClient } from "@tanstack/react-query";
import { useAnneeScope } from "@/lib/annee-scope";

/**
 * Déroulant des années scolaires disponibles. Caché si l'école n'en a qu'une.
 * Au changement : met à jour le scope (sessionStorage + header) et invalide
 * les requêtes pour refetch sur la nouvelle année.
 */
export default function AnneeSelector() {
  const { anneeId, setAnneeId, annees } = useAnneeScope();
  const qc = useQueryClient();
  if (annees.length <= 1) return null;
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-white/70">Année :</span>
      <select
        value={anneeId ?? ""}
        onChange={(e) => {
          setAnneeId(e.target.value);
          qc.invalidateQueries();
        }}
        className="bg-white/10 border border-white/20 rounded px-2 py-1 text-white"
        data-testid="select-annee"
      >
        {annees.map((a) => (
          <option key={a.id} value={a.id} className="text-navy">
            {a.libelle}{a.estActive ? " (active)" : a.statut === "CLOTUREE" ? " (clôturée)" : ""}
          </option>
        ))}
      </select>
    </label>
  );
}
